import {
  expressFleetConfigListUrl,
  expressFleetOpsPageUrl
} from "@saleor/autobooking/urls";
import { WindowTitle } from "@saleor/components/WindowTitle";
import useNavigator from "@saleor/hooks/useNavigator";
import useUser from "@saleor/hooks/useUser";
import ShippingMethods from "@saleor/icons/ShippingMethods";
import Taxes from "@saleor/icons/Taxes";
import { sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { remittanceConfigSection } from "@saleor/riderRemittanceConfig/urls";
import { shippingZonesListUrl } from "@saleor/shipping/urls";
import { PermissionEnum } from "@saleor/types/globalTypes";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import React from "react";
import { IntlShape, useIntl } from "react-intl";

import ConfigurationOpsPage, { MenuSection } from "./ConfigurationOpsPage";

export function createConfigurationOpsMenu(intl: IntlShape): MenuSection[] {
  const user = useUser();
  return [
    {
      label: intl.formatMessage({
        defaultMessage: "Remittance"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Manage riders during remittance",
            id: "configurationOpsMenuRemittance"
          }),
          icon: <Taxes fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_REMITTANCE_CONFIG,
          title: intl.formatMessage(sectionNames.riderRemittance),
          url: remittanceConfigSection
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Fulfillment"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Assign autobooking for orders",
            id: "configurationOpsMenuExpressFleet"
          }),
          icon: <Taxes fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_AUTO_BOOKING,
          title: intl.formatMessage(sectionNames.expressFleet),
          url:
            user?.user?.userType?.code === SmopUserTypeCode.OMI_OPS
              ? expressFleetOpsPageUrl
              : expressFleetConfigListUrl
        }
      ]
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Shipping Settings"
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            defaultMessage: "Manage how you ship out orders",
            id: "configurationMenuShipping"
          }),
          icon: <ShippingMethods fontSize="inherit" viewBox="0 0 44 44" />,
          permission: PermissionEnum.MANAGE_SHIPPING,
          title: intl.formatMessage(sectionNames.shipping),
          url: shippingZonesListUrl()
        }
      ]
    }
  ];
}

export const configurationOpsMenuUrl = "/operations/";

export const ConfigurationOpsSection: React.FC = () => {
  const navigate = useNavigator();
  const user = useUser();
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.configuration)} />
      <ConfigurationOpsPage
        menu={createConfigurationOpsMenu(intl)}
        user={maybe(() => user.user)}
        onSectionClick={navigate}
      />
    </>
  );
};
export default ConfigurationOpsSection;
